module.exports = __webpack_public_path__ + "static/media/i-logo.f9cd9ec8.png";